import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { ResourceSectionContainer } from "../shared/ResourceSectionContainer";
import { useLinkSections } from "./constants";

const localeRoot = "community_onboarding.new_checklist.circle_app_links";

export const CircleAppLinks = () => {
  const linkSections = useLinkSections();

  return (
    <div>
      <div className="mb-4">
        <Typography.LabelMd weight="semibold">
          {t(`${localeRoot}.title`)}
        </Typography.LabelMd>
      </div>
      <ResourceSectionContainer sections={linkSections} />
    </div>
  );
};
